// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01jfw{margin-left:var(--ds-space-500,40px)}\n._19pk1jfw{margin-top:var(--ds-space-500,40px)}\n._2hwx1jfw{margin-right:var(--ds-space-500,40px)}\n._otyr1jfw{margin-bottom:var(--ds-space-500,40px)}\n._syaz1fxt{color:var(--ds-text,#172b4d)}", ""]);
// Exports
module.exports = exports;
